module.exports = __webpack_public_path__ + "assets/img/special.1e4b12b9.svg";